import { Injectable } from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Lista} from "../model/lista";
import {Utiles} from '../pages/utiles/utiles';
// tslint:disable-next-line:quotemark
import {Comprador} from "../model/Comprador";
import {tap} from "rxjs/operators";
import {CompradorLugarEntrega} from "../model/comprador-lugar-entrega";
import {Rubro} from "../model/rubro";


@Injectable()
export class RubroService {
    private api: string;
    constructor(private http: HttpClient) {
// tslint:disable-next-line:whitespace
        this.api=Utiles.api+'rubro';
    }
    getLista(ejemplo: Rubro): Observable<Lista<Rubro>> {
        return this.http.get<Lista<Rubro>>(this.api+
            '?orderBy='+encodeURI('rubro')+
            '&orderDir='+encodeURI('asc')+
            '&ejemplo='+encodeURI(JSON.stringify(ejemplo))+
            '&like=S');
    }

    get(id: number): Observable<Rubro> {
        return this.http.get<Rubro>(this.api+'/'+id);
    }

    agregar(p: Rubro): Observable<Rubro>{
        return this.http.post<Rubro>(this.api,p)
            .pipe(
                tap(
                    data => console.log('agregado: '+data),
                    error => console.log('error: '+error)
                ));
    }

    modificar(p: Rubro): Observable<Rubro>{
        return this.http.put<Rubro>(this.api, p)
            .pipe(
                tap(
                    data => console.log('agregado: '+data),
                    error => console.log('error: '+error)
                ));
    }

    eliminar(id: number): Observable<{}>{

        return this.http.delete(this.api+'/'+id)
            .pipe(
                tap(
                    data => console.log('eliminado'),
                    error => console.log('eliminado'),
                ));


    }
}
